
import './app.css'
import Accordion from "./components/Accordion"
import {useState,useEffect} from 'react'
import Switch from "./components/Switch"
import SendData from "./SendData"
import {useNavigate , useLocation} from "react-router-dom";


//import {SendData} from "./HomeApp"

function Modal ({boards,onSelect,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <div style={modalStyle}>
        <h3 className="board-item">
          انتخاب گلخانه
        </h3>
        {
            boards.map ( (board,key)=>{
              return(
            <div
              key={key}
              onClick={()=>{onSelect (board,key);}}
              /*style={itemStyle}*/
              className="board-item"
              >
              {board.name}
            </div>
          )})
       }
        <button   style={style.button}  /*style={{backgroundColor:'#0ff',}}*/ onClick={onClose} >
          کنسل
        </button>
      </div>
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};

const itemStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  cursor: 'pointer'
};





function MenuTimeSetting ({socket}){
  const [code,setCode] = useState ("");
  const id=localStorage.getItem ('id');
  const phone=localStorage.getItem ('phone');
  const boards=JSON.parse(localStorage.getItem ('boards'));
  const [select_board,setSelect_board]= useState (localStorage.getItem ('select_board'));
  const [seletedBoard,setSelectedBoard]=useState(boards[select_board]);
  const [showModal,setShowModal]=useState(false);
  const [data,setData] = useState ({});
  const navigate = useNavigate ();


  const [menuTime, setMenuTime] = useState({});
  const [on_hoter,setOn_hoter]=useState (0);

  const[change,setChange]=useState (false);

  const location = useLocation ();



  useEffect (()=>{
    var data = location.state;
    if (data.window_air==undefined)data.window_air={temp_open:20,darsad_open:0};
    if (data.fan_hoter==undefined)data.fan_hoter={dama_on:20,time_on:1,time_off:1};
    setMenuTime (data);
  //  window.alert (JSON.stringify(data.fan_pad));
    return () =>{
    socket.off ('message');
  };

},[socket]);


  return (
    <div  className="page" /* style={style.container}*/>
      <div className="content" >
        <Accordion title = {"دما (کنترل بخاری و کولر)"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای روشن شدن بخاری
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.temp!=undefined && menuTime.temp.on_hoter!=undefined) ? menuTime.temp.on_hoter : ''}
            onChange = {(e)=>{var a=menuTime; a.temp.on_hoter=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای خاموش شدن بخاری
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.temp!=undefined && menuTime.temp.off_hoter!=undefined) ? menuTime.temp.off_hoter : ''}
            onChange = {(e)=>{var a=menuTime; a.temp.off_hoter=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای روشن شدن کولر
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.temp!=undefined && menuTime.temp.on_coler!=undefined) ? menuTime.temp.on_coler : ''}
            onChange = {(e)=>{var a=menuTime; a.temp.on_coler=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای خاموش شدن کولر
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4 , textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.temp!=undefined && menuTime.temp.off_coler!=undefined) ? menuTime.temp.off_coler : ''}
            onChange = {(e)=>{var a=menuTime; a.temp.off_coler=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>


        <Accordion title = {"رطوبت (کنترل مه پاش)"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            بیشترین رطوبت مجاز
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.humid!=undefined && menuTime.humid.max_humid!=undefined) ? menuTime.humid.max_humid : ''}
            onChange = {(e)=>{var a=menuTime; a.humid.max_humid=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            کمترین رطوبت مجاز
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.humid!=undefined && menuTime.humid.min_humid!=undefined) ? menuTime.humid.min_humid : ''}
            onChange = {(e)=>{var a=menuTime; a.humid.min_humid=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
            زمان روشن بودن مه پاش
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.humid!=undefined && menuTime.humid.time_on!=undefined) ? menuTime.humid.time_on : ''}
            onChange = {(e)=>{var a=menuTime; a.humid.time_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            زمان خاموش بودن مه پاش
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4 , textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.humid!=undefined && menuTime.humid.time_off!=undefined) ? menuTime.humid.time_off : ''}
            onChange = {(e)=>{var a=menuTime; a.humid.time_off=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>


        <Accordion title = {"فن بخاری ها"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای روشن شدن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_hoter!=undefined && menuTime.fan_hoter.dama_on!=undefined) ? menuTime.fan_hoter.dama_on : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_hoter.dama_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            مدت روشن بودن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_hoter!=undefined && menuTime.fan_hoter.time_on!=undefined) ? menuTime.fan_hoter.time_on : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_hoter.time_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
            مدت خاموش بودن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_hoter!=undefined && menuTime.fan_hoter.time_off!=undefined) ? menuTime.fan_hoter.time_off : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_hoter.time_off=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>

        <Accordion title = {"تنظیمات سیر سیرکوله"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            زمان روشن بودن سیرکوله
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.sirkole!=undefined && menuTime.sirkole.time_on!=undefined) ? menuTime.sirkole.time_on : ''}
            onChange = {(e)=>{var a=menuTime; a.sirkole.time_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            زمان خاموش بودن سیرکوله
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.sirkole!=undefined && menuTime.sirkole.time_off!=undefined) ? menuTime.sirkole.time_off : ''}
            onChange = {(e)=>{var a=menuTime; a.sirkole.time_off=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>

        <Accordion title = {"باز شدن پنجره برای کاهش دما"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_temp!=undefined && menuTime.window_temp.temp_open!=undefined) ? menuTime.window_temp.temp_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_temp.temp_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            درصد باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_temp!=undefined && menuTime.window_temp.darsad_open!=undefined) ? menuTime.window_temp.darsad_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_temp.darsad_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             افزایش درصد باز شدن به ازای هر درجه افزایش دما
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_temp!=undefined && menuTime.window_temp.add_darsad!=undefined) ? menuTime.window_temp.add_darsad : ''}
            onChange = {(e)=>{var a=menuTime; a.window_temp.add_darsad=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             بیشترین درصد باز شدن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_temp!=undefined && menuTime.window_temp.max_darsad!=undefined) ? menuTime.window_temp.max_darsad : ''}
            onChange = {(e)=>{var a=menuTime; a.window_temp.max_darsad=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>

        <Accordion title = {"باز شدن اجباری پنجره در باد زیاد"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_air!=undefined && menuTime.window_air.temp_open!=undefined) ? menuTime.window_air.temp_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_air.temp_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            درصد باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_air!=undefined && menuTime.window_air.darsad_open!=undefined) ? menuTime.window_air.darsad_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_air.darsad_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>


        <Accordion title = {"باز شدن پنجره برای کاهش رطوبت"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            رطوبت باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_humid!=undefined && menuTime.window_humid.humid_open!=undefined) ? menuTime.window_humid.humid_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_humid.humid_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            درصد باز شدن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_humid!=undefined && menuTime.window_humid.darsad_open!=undefined) ? menuTime.window_humid.darsad_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_humid.darsad_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             مدت باز بودن پنجر
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_humid!=undefined && menuTime.window_humid.time_open!=undefined) ? menuTime.window_humid.time_open : ''}
            onChange = {(e)=>{var a=menuTime; a.window_humid.time_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             مدت بسته بودن پنجره
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.window_humid!=undefined && menuTime.window_humid.time_close!=undefined) ? menuTime.window_humid.time_close : ''}
            onChange = {(e)=>{var a=menuTime; a.window_humid.time_close=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>


        <Accordion title = {"فن تخلیه رطوبت"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            رطوبت روشن شدن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_humid!=undefined && menuTime.fan_humid.darsad_on!=undefined) ? menuTime.fan_humid.darsad_on : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_humid.darsad_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            مدت روشن بودن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_humid!=undefined && menuTime.fan_humid.time_on!=undefined) ? menuTime.fan_humid.time_on : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_humid.time_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             مدت خاموش بودن فن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_humid!=undefined && menuTime.fan_humid.time_off!=undefined) ? menuTime.fan_humid.time_off : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_humid.time_off=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>

        {(menuTime.off_humid_hoter!=null)?
         <Accordion title = {"کاهش رطوبت با روشن شدن بخاری"}>
         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 ,marginLeft:30 , marginRight:30}} >
             فعال کردن سیستم
           </h2>
           <Switch  style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.mode!=undefined)?(menuTime.off_humid_hoter.mode==0)?false:true : false}
             onChange = {()=>{var a=menuTime; if (a.off_humid_hoter.mode==0)a.off_humid_hoter.mode='1'; else a.off_humid_hoter.mode='0'; setMenuTime (a); setChange (!change);  }}
           />
         </div>
         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
             دمای روشن کردن
           </h2>
           <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             type="tel"
             placeholder = ""
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.in_dama!=undefined) ? menuTime.off_humid_hoter.in_dama : ''}
             onChange = {(e)=>{var a=menuTime; a.off_humid_hoter.in_dama=e.target.value; setMenuTime (a); setChange (!change);  }}/>
         </div>

         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
             بیشترین رطوبت داخل
           </h2>
           <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             type="tel"
             placeholder = ""
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.in_humid!=undefined) ? menuTime.off_humid_hoter.in_humid : ''}
             onChange = {(e)=>{var a=menuTime; a.off_humid_hoter.in_humid=e.target.value; setMenuTime (a); setChange (!change);  }}/>
         </div>

         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
             بیشترین رطوبت بیرون
           </h2>
           <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             type="tel"
             placeholder = ""
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.out_humid!=undefined) ? menuTime.off_humid_hoter.out_humid : ''}
             onChange = {(e)=>{var a=menuTime; a.off_humid_hoter.out_humid=e.target.value; setMenuTime (a); setChange (!change);  }}/>
         </div>
         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 ,marginLeft:30 , marginRight:30}} >
             روشن شدن مشعل
           </h2>
           <Switch  style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.on_hoter!=undefined)?((menuTime.off_humid_hoter.on_hoter==0)?false:true) : false}
             onChange = {(e)=>{var a=menuTime;  if (a.off_humid_hoter.on_hoter==0){a.off_humid_hoter.on_hoter='1';} else {a.off_humid_hoter.on_hoter='0';}    setMenuTime (menuTime); setChange (!change);  }}
           />
         </div>
         <div  className="row"  >
           <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
             مدت زمان روشن بودن
           </h2>
           <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
             type="tel"
             placeholder = ""
             value={(menuTime.off_humid_hoter!=undefined && menuTime.off_humid_hoter.time_on!=undefined) ? menuTime.off_humid_hoter.time_on : ''}
             onChange = {(e)=>{var a=menuTime; a.off_humid_hoter.time_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
         </div>

         </Accordion>
       :null}



       {(menuTime.fan_pad!=null)?
        <Accordion title = {"فن و پد"}>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 ,marginLeft:30 , marginRight:30}} >
            فعال کردن فن و پد
          </h2>
          <Switch  style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.mode!=undefined)?(menuTime.fan_pad.mode==0)?false:true : false}
            onChange = {()=>{var a=menuTime; if (a.fan_pad.mode==0)a.fan_pad.mode='1'; else a.fan_pad.mode='0'; setMenuTime (a); setChange (!change);  }}
          />
        </div>
        <div  className="row"  >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            دمای روشن شدن
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.dama_on!=undefined) ? menuTime.fan_pad.dama_on : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_pad.dama_on=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 , margin:0 ,alignSelf:"center", flex:.8 }} >
            کمترین سرعت
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.min_speed!=undefined) ? menuTime.fan_pad.min_speed : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_pad.min_speed=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             افزایش سرعت برای هر درجه
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.add_speed!=undefined) ? menuTime.fan_pad.add_speed : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_pad.add_speed=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             زمان روشن شدن پمپ
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.time_pump!=undefined) ? menuTime.fan_pad.time_pump : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_pad.time_pump=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        <div  className="row" >
          <h2 style={{ fontSize:20 ,margin:0 ,alignSelf:"center", flex:.8 }} >
             باز شدن پنجره فن و پد
          </h2>
          <input style={{margin:10,padding:5,fontSize:20, flex:.2,width:"50%",borderRadius:4, textAlign:"center"}}
            type="tel"
            placeholder = ""
            value={(menuTime.fan_pad!=undefined && menuTime.fan_pad.darsad_open!=undefined) ? menuTime.fan_pad.darsad_open : ''}
            onChange = {(e)=>{var a=menuTime; a.fan_pad.darsad_open=e.target.value; setMenuTime (a); setChange (!change);  }}/>
        </div>
        </Accordion>
      :null}

        <button className="btn2" /* style={style.button}*/
          onClick ={()=>{
            socket.off ('message');
            socket.on ('message',(data)=>{
                  if (JSON.parse(data).event=="SET_MENU_TIME" && JSON.parse(data).data==true)
                  {
                    window.alert ('اطلاعات با موفقیت ذخیره شد');
                    socket.off ('message');
                    navigate (-1);
                  }
              });
              SendData (socket,'data',{
                      "event":"set_menu_time",
                      "id":menuTime.time.id+'',  // route.params.id+'',
                      "data":menuTime
                    });
               }}>
           تایید
        </button>
     </div>



    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default MenuTimeSetting;
